
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.5 20a8.5 8.5 0 10-8.057-5.783c.108.32.162.481.172.604a.899.899 0 01-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 00.234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0012.5 20zm-.852-11.777a1.473 1.473 0 011.037-.2c.354.064.686.259.93.564.246.305.386.7.385 1.114v.001c0 .39-.288.804-.86 1.204a4.957 4.957 0 01-1.033.546l-.01.004a1 1 0 00.66 1.888 6.96 6.96 0 001.53-.799C15 12.045 16 11.11 16 9.703c.001-.86-.288-1.7-.825-2.369a3.548 3.548 0 00-2.136-1.28 3.472 3.472 0 00-2.44.467 3.673 3.673 0 00-1.547 1.964 1 1 0 001.896.636c.13-.387.382-.702.7-.898zM12.46 15a1 1 0 100 2h.012a1 1 0 100-2h-.012z","fill":"#fff"}})])
          )
        }
      }
    